import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from "@material-ui/core";

import React from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import moment from "moment";
import _ from "lodash";
import { API_URL } from "../../constants/api";
import {
  apiDelete,
  apiPost,
  apiPut,
  apiRequest
} from "../../utils/api_service";
import { ShowToast, toastType } from "../../utils/toast-service";
import { GetEnableProperty, isGridFormValid, removeDuplicates } from "../../utils/helper";
import GridTable from "../common/Table/Table";
import ConfirmDialog from "../common/Dailogbox/ConfirmDailog";
import { SECTIONS } from "../../constants/appConstants";
const mappingColumnsList = [
  {
    name: "Request Type",
    key: "RequestType",
    idField: "RequestTypeId",
    type: "Child",
    isRequired: true,
    isVisible: true,
    dataFormat: "Text",
    editConfig: {
      type: "DropDown",
      sourceKey: "requestTypeMaster",
      updateKey: "RequestTypeId",
      sourceOption: "RequestType",
      title: "Request Type",
      isEditField: false,
      isAddField: true,
      multiple: false,
      delimiter: "|"
    }
  },
  {
    name: "Department",
    key: "EmployeeDepartments",
    idField: "EmployeeDepartmentIds",
    isRequired: true,
    isVisible: true,
    dataFormat: "MultiText",
    minTag: 5,
    editConfig: {
      type: "DropDown",
      sourceKey: "employeeDepartmentMaster",
      updateKey: "EmployeeDepartmentId",
      sourceOption: "Department",
      title: "Department",
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: ","
    }
  },
  {
    name: "Data Center",
    key: "PropertyName",
    idField: "PropertyId",
    isRequired: true,
    isVisible: true,
    dataFormat: "Text",
    minTag: 5,
    editConfig: {
      type: "DropDown",
      sourceKey: "propertyMaster",
      updateKey: "PropertyId",
      sourceOption: "Abbreviation",
      title: "Property",
      isEditField: false,
      isAddField: true,
      multiple: false,
      delimiter: "|"
    }
  },
  {
    name: "Actions",
    key: "MappingId",
    renderComponent: "renderActionColumn",
    minWidth: 90
  }
];

export default class ConfigureRequestTypeDepartmentAndSiteMapping extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirmMessage: null,
      showWarningMessage: false,
      burdenMasterData: [],
      isInAddMode: false,
      selectedEditRowId: undefined,
      validationMessage: [],
      updateData: {
        requestTypeId: 0,
        RequestType: "",
        EmployeeDepartmentIds: "string",
        Department: "",
        propertyId: 0,
        PropertyName: "",
        MappingId: 0
      },
      mappingColumns: _.cloneDeep(mappingColumnsList)
    };
  }

  componentDidMount() {
    this.getRequiredData();
  }

  /**
   * delete record
   */
  deleteRecord(cellInfo) {
    this.setState({
      showWarningMessage: true,
      confirmMessage: "Do you want to delete this record ?",
      updateData: cellInfo
    });
  }

  /**
   * handle on delete
   * @param {*} e
   */
  onDeleteHandel(e) {
    const newParam = this.state.updateData;
    if (e) {
      newParam.startDate = null; // '0001-01-01'
      this.setState({
        updateData: newParam,
        showWarningMessage: false
      });
      this.saveRecord(newParam);
    } else {
      this.setState({ showWarningMessage: false });
    }
  }

  /**
   * return master data from
   */
  getRequiredData = () => {

    apiRequest({ url: API_URL.request.GetRequestMasterData }).then(
      ({ data }) => {
        data.propertyMaster = GetEnableProperty((data.propertyMaster || []), SECTIONS.CONFIGURE_REQUEST_TYPE_DEPARTMENT_AND_DATA_CENTER, "PropertyId");
        this.setState({
          employeeDepartmentMaster: data.employeeDepartmentMaster,
          requestTypeMaster: data.requestTypeMaster,
          propertyMaster: data.propertyMaster
        });
      }
    );

    apiRequest({ url: API_URL.request.GetRequestTypeDepartmentMapping }).then(
      ({ data: empPropertyList }) => {
        this.setState({
          requestTypeDepartmentData: empPropertyList
        });
      }
    );
  };

  /**
   * check if designation is present burden master data
   * @param {*} ele
   * @returns
   */
  isDesignationPresent(ele) {
    const existingDepartmentId = ele.designationId.split("|");
    const newDepartmentId = this.state.updateData.designationId.split("|");

    const matchedDepartment = existingDepartmentId.filter(m =>
      newDepartmentId.some(n => m === n)
    );
    return matchedDepartment;
  }

  /**
   * check for exist in burden group
   * @returns 
   */
  isDeptExistInBurdenGroup() {
    let newParam = [];
    let isValid = false;
    let isStartDateSame = false;
    let isNewParamValid = false;
    newParam = this.state.updateData;
    let filterBurdenData = "";
    let breakCondition = false;

    this.state.burdenMasterData.forEach(ele => {
      if (
        ele.burdenRateId !== this.state.updateData.burdenRateId &&
        ele.endDate !== null &&
        !breakCondition &&
        ele.endDate !== "0001-01-01T00:00:00" &&
        this.state.updateData.startDate >=
          moment(ele.startDate).format("YYYY/MM/DD") &&
        this.state.updateData.startDate <=
          moment(ele.endDate).format("YYYY/MM/DD")
      ) {
        const matchedDepartment = this.isDesignationPresent(ele);
        if (matchedDepartment.length > 0) {
          breakCondition = true;
          newParam = null;
          isValid = true;
        }
      }
    });

    if (!isValid) {
      this.state.burdenMasterData.forEach(ele => {
        if (
          ele.burdenRateId !== this.state.updateData.burdenRateId &&
          !breakCondition &&
          ele.endDate !== null &&
          ele.endDate === "0001-01-01T00:00:00"
          // && this.isDateInSamePayCycle(moment(ele.startDate).format("YYYY-MM-DD"),this.state.updateData.startDate)
        ) {
          const matchedDepartment = this.isDesignationPresent(ele);
          if (matchedDepartment.length > 0) {
            if (ele.designationId === this.state.updateData.designationId) {
              isNewParamValid = true;
            } else if (
              moment(ele.startDate).format("YYYY/MM/DD") >=
                this.state.updateData.startDate ||
              this.isDateInSamePayCycle(
                moment(ele.startDate).format("YYYY/MM/DD"),
                this.state.updateData.startDate
              )
            ) {
              isStartDateSame = true;
            }
            filterBurdenData = ele;
            breakCondition = true;
          }
          // return;
        }
      });
      if (isStartDateSame) {
        newParam = false;
      } else if (isNewParamValid) {
        newParam = true;
      } else if (filterBurdenData !== null && filterBurdenData !== undefined) {
        newParam.parentRecordId = filterBurdenData.burdenRateId;

        this.setState({
          updateData: newParam
        });
      }
    }

    return newParam;
  }

  /**
   * Save record
   * @param {*} newParam 
   * @returns 
   */
  saveRecord(newParam) {
    if (!newParam) return;
    if (newParam.MappingId === 0) {
      this.saveNewRecord(newParam);
    } else {
      apiPut({
        url: API_URL.request.UpdateRequestTypeDepartmentMapping,
        postBody: {
          employeeDepartmentIds: newParam.EmployeeDepartmentIds,
          propertyId: newParam.PropertyId,
          requestTypeId: newParam.RequestTypeId
        }
      }).then(({ data: response }) => {
        if (response.success === true) {
          ShowToast(
            this.state.isInAddMode
              ? "Record added successfully."
              : "Record updated successfully.",
            toastType.SUCCESS,
            5000,
            500
          );

          this.setState({
            updateData: undefined,
            selectedEditRowId: undefined,
            showWarningMessage: false,
            isInAddMode: false
          });
          this.getRequiredData();
        } else {
          ShowToast(response.message, toastType.ERROR, 5000, 5000);
        }
      });
    }
  }

  /**
   * save newly record
   * @param {*} newParam 
   * @returns 
   */
  saveNewRecord(newParam) {
    if (!newParam) return;
    apiPost({
      url: API_URL.request.AddRequestTypeDepartmentMapping,
      postBody: {
        employeeDepartmentIds: newParam.EmployeeDepartmentIds,
        propertyId: newParam.propertyId,
        requestTypeId: newParam.requestTypeId
      }
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(
          this.state.isInAddMode
            ? "Record added successfully."
            : "Record updated successfully.",
          toastType.SUCCESS,
          5000,
          500
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          showWarningMessage: false,
          isInAddMode: false
        });
        this.getRequiredData();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  }

  /**
   * call on table value updation
   * @param {*} value 
   * @param {*} fieldName 
   */
  handleTableEditChange = (value, fieldName) => {
    const employeeDepartmentMaster = this.state.employeeDepartmentMaster;
    const propertyMaster = this.state.propertyMaster;
    const requestTypeMaster = this.state.requestTypeMaster;
    const { updateData } = this.state;
    const validationMessage = this.state.validationMessage;

    if (fieldName === "EmployeeDepartments") {
      const valueOfDepartments = [];
      const valueOfDepartmentIds = [];
      value.forEach(val => {
        if (employeeDepartmentMaster.find(x => x.Department === val)) {
          valueOfDepartments.push(
            employeeDepartmentMaster.find(x => x.Department === val).Department
          );
          valueOfDepartmentIds.push(
            employeeDepartmentMaster.find(x => x.Department === val)
              .EmployeeDepartmentId
          );
        }
      });
      updateData.EmployeeDepartmentIds = valueOfDepartmentIds.join(",");
      updateData[fieldName] = value.join(",");
    } else if (fieldName === "PropertyName") {
      if (propertyMaster.find(x => x.Abbreviation === value)) {
        updateData.PropertyId = propertyMaster.find(
          x => x.Abbreviation === value
        ).PropertyId;
        updateData.propertyId = propertyMaster.find(
          x => x.Abbreviation === value
        ).PropertyId;
      }
      updateData[fieldName] = value;
    } else if (fieldName === "RequestType") {
      if (requestTypeMaster.find(x => x.RequestType === value)) {
        updateData.RequestTypeId = requestTypeMaster.find(
          x => x.RequestType === value
        ).RequestTypeId;
        updateData.requestTypeId = requestTypeMaster.find(
          x => x.RequestType === value
        ).RequestTypeId;
      }
      updateData[fieldName] = value;
    } else {
      updateData[fieldName] = value;
    }
    this.setState({
      updateData: updateData,
      validationMessage: (validationMessage || []).filter(x => {
        return x.key !== fieldName;
      })
    });

    this.forceUpdate();
  };

  /**
   * add new record in grid table
   * @returns
   */
  AddNewRecord = () => {
    if (this.state.isInAddMode) {
      ShowToast("You can add one row at a time!", toastType.WARNING, 5000, 500);
      return false;
    }
    const mappingColumns = _.cloneDeep(mappingColumnsList);
    const rowNew = {
      requestTypeId: 0,
      RequestType: "",
      EmployeeDepartmentIds: "string",
      Department: "",
      propertyId: 0,
      PropertyName: "",
      MappingId: 0
    };
    const { reloadTable } = this.state;
    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: "MappingId", value: 0 },
      updateData: rowNew,
      reloadTable: !reloadTable,
      mappingColumns
    });
  };

  /**
   * cancel row open for add mode
   */
  cancelAddMode = () => {
    const { reloadTable } = this.state;
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !reloadTable
    });
  };

  /**
   * Save updated record
   * @returns 
   */
  saveUpdatedRecord = () => {
    if (!this.isValidForm()) {
      return false;
    } else {
      this.saveRecord(this.state.updateData);
    }
  };

  /**
   * Check form validation
   * @returns 
   */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, mappingColumns } = this.state;
    mappingColumns.forEach(ele => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState) {
        IsValid = false;
      }
    });
    this.setState(mappingColumns, this.forceUpdate());
    return IsValid;
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    const { reloadTable } = this.state;
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !reloadTable
    });
  };

  /**
   * Edit record
   * @param {*} cellInfo 
   */
  EditRecord = cellInfo => {
    const mappingColumns = _.cloneDeep(mappingColumnsList);
    cellInfo.EmployeeDepartmentIds = removeDuplicates(
      cellInfo.EmployeeDepartmentIds.split(",")
    ).join(",");
    cellInfo.EmployeeDepartments = removeDuplicates(
      cellInfo.EmployeeDepartments.split(",")
    ).join(",");
    const { reloadTable } = this.state;

    this.setState({
      selectedEditRowId: {
        key: "MappingId",
        value: cellInfo.MappingId
      },
      isInAddMode: false,
      updateData: { ...cellInfo },
      reloadTable: !reloadTable,
      mappingColumns
    });
  };

  /**
   * Render action column (Save/add/update/delete)
   * @param {*} cellInfo 
   * @param {*} isInAddMode 
   * @returns 
   */
  renderActionColumn = (cellInfo, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
        cellInfo.MappingId === this.state.selectedEditRowId.value ? (
          <>
            <Tooltip title={"Save Record"}>
              <IconButton
                aria-label={"refreshData"}
                size={"small"}
                onClick={this.saveUpdatedRecord}
              >
                <SaveIcon fontSize={"small"} size={"small"} />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Cancel"}>
              <IconButton
                aria-label={"refreshData"}
                size={"small"}
                onClick={isInAddMode ? this.cancelAddMode : this.cancelEditMode}
              >
                <CancelIcon fontSize={"small"} size={"small"} />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            {" "}
            {true && (
              <Tooltip title={"Edit Record"}>
                <IconButton
                  aria-label={"refreshData"}
                  size={"small"}
                  onClick={() => {
                    if (
                      this.state.isInAddMode === true ||
                      this.state.selectedEditRowId !== undefined
                    ) {
                      ShowToast(
                        "You can add/Edit one row at a time!",
                        toastType.WARNING,
                        5000,
                        500
                      );
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize={"small"} size={"small"} />
                </IconButton>
              </Tooltip>
            )}
            {
              <Tooltip title={"Delete"}>
                <IconButton
                  aria-label={"refreshData"}
                  size={"small"}
                  onClick={() => {
                    this.deleteRecord(cellInfo);
                  }}
                >
                  <DeleteIcon fontSize={"small"} size={"small"} />
                </IconButton>
              </Tooltip>
            }
          </>
        )}
      </>
    );
  };

  /**
   * call onclick
   * @param {*} isDelete 
   */
  onClickHandel(isDelete) {
    const { updateData } = this.state;

    if (isDelete) {
      apiDelete({
        url:
          API_URL.request.DeleteRequestTypeDepartmentMapping +
          "?requestTypeId=" +
          updateData.RequestTypeId +
          "&propertyId=" +
          updateData.PropertyId
      }).then(response => {
        response.success == false
          ? ShowToast(
              "Server Error: Unable to delete Request.",
              toastType.ERROR,
              5000,
              500
            )
          : ShowToast(
              "Request has been deleted successfully.",
              toastType.SUCCESS,
              5000,
              200
            );
        this.setState(
          {
            showWarningMessage: false,
          },
          () => {
            this.getRequiredData();
          }
        );
      });
    } else {
      this.setState({
        showWarningMessage: false,
      });
    }

    // if (this.state.isDelete) {
    //   this.onDeleteHandel(e);
    // } else {
    //   this.setState({
    //     showWarningMessage: false
    //   });
    //   let newParam = [];
    //   newParam = this.state.updateData;
    //   newParam.splitDesignation = e;
    //   if (e) this.saveRecord(newParam);
    // }
  }

  render() {
    const {
      propertyMaster,
      requestTypeMaster,
      employeeDepartmentMaster,
      mappingColumns,
      updateData
    } = this.state;

    const EditSource = [];
    EditSource.push({
      key: "propertyMaster",
      data: propertyMaster
    });
    EditSource.push({
      key: "requestTypeMaster",
      data: requestTypeMaster
    });
    EditSource.push({
      key: "employeeDepartmentMaster",
      data: employeeDepartmentMaster
    });

    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={isValid => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText={"Yes"}
            DisAgreeText={"No"}
          />
        )}

        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={"configureHeader"}
                className={"content-header"}
                colSpan={2}
              >
                <div className={"content-header d-flex"}>
                  {" "}
                  <div
                    className={"col-xs-11"}
                    style={{ display: "inline-block", alignItems: "center" }}
                  >
                    {"Request Type, Department and Data Center Configuration\r"}
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  validationMessage={this.state.validationMessage || []}
                  columns={mappingColumns}
                  data={this.state.requestTypeDepartmentData}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={updateData}
                  AddNewRecord={{
                    action: this.AddNewRecord,
                    title: "Add New Mapping",
                    visible: true
                  }}
                  isInline
                  reload={this.state.reloadTable}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
